import React, { useEffect } from 'react';
import styled from 'styled-components';
import {
  imgWho,
  imgHow,
  imgHowMobile,
  ourDirection1,
  ourDirection2
} from 'assets/images';
import { device } from 'utils/constants';

const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 30px 20px 100px;
`;

const Thumbnail = styled.div`
  max-width: 250px;
  width: 100%;
  margin-top: 20px;

  @media ${device.desktop} {
    margin-top: 0;
  }
`;

const Image = styled.img`
  width: 100%;
`;

const AboutSection = styled.section`
  margin-bottom: 50px;

  @media ${device.desktop} {
    margin-bottom: 0;
  }
`;

const AboutContent = styled.div`
  display: flex;
  flex-direction: column;
  
  p {
    margin-top: 20px;

    font-size: 13px;
    line-height: 25px;
    word-break: keep-all;
  }

  @media ${device.desktop} {
    flex-direction: row;
    justify-content: space-between;
    gap: 50px;
    
    p {
      font-size: 15px;
      line-height: 30px;
    }
  }
`;

const HowContent = styled.div`
  p {
    margin: 20px 0;

    font-size: 13px;
    line-height: 25px;
  }

  @media ${device.desktop} {
    margin-top: 80px;
    
    p {
      font-size: 15px;
      line-height: 30px;
    }
  }
`;

const OurContent = styled.div`
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  
  p {
    margin-top: 20px;
    margin-bottom: 15px;

    font-size: 13px;
    line-height: 25px;
  }

  @media ${device.desktop} {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    gap: 20px;
    
    p {
      font-size: 15px;
      line-height: 30px;
    }
  }
`;

const OurContentRight = styled.div`
  margin-top: 10px;
  
  @media ${device.desktop} {
    margin-top: 0;
    max-width: 400px;
  }
`;

const SectionTitle = styled.h1`
  font-size: 25px;
  //font-weight: bold;

  @media ${device.desktop} {
    font-size: 28px;
    letter-spacing: 0.1em;
  }
`;

export default () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Wrapper>
      <AboutSection>
        <AboutContent>
          <div>
            <SectionTitle>Who We Are</SectionTitle>
            <p className='korean'>
              노르웨이숲 디자인은 손으로 재료를 다루는 아버지의 공예 작업실에서 자란  남매 디자이너
              김성수와 김은선이 함께 <br/>2011년 7월에 설립한 공간디자인 스튜디오입니다.<br/>
              제작과 조형의 과정을 가까이에서 지켜보며 자라온 우리는,
              공간을 겉으로 드러나는 결과보다 제작의 논리와 기술, <br/>그리고 손과 시간이 쌓여 완성되는
              구조와 과정으로 바라보는 기준과 태도를 가지게 되었습니다.
            </p>
          </div>

          <Thumbnail>
            <Image src={imgWho} alt="who" />
          </Thumbnail>
        </AboutContent>
      </AboutSection>

      <AboutSection>
        <AboutContent>
          <div>
            <SectionTitle>What We Do</SectionTitle>
            <p className='korean'>
              우리는 삶의 방식과 사용자의 취향, 그리고 브랜드의 성격과 운영의 논리를 중심으로 공간을 설계합니다.<br/>
              공간의 용도와 규모에 따라 기획, 디자인, 실행 전 과정에 참여하며 프로젝트에 가장 적합한 방식으로 공간을 완성합니다.
            </p>
          </div>
        </AboutContent>
      </AboutSection>

      <AboutSection>
        <HowContent>
          <div>
            <SectionTitle>How We Work</SectionTitle>
            <p className='korean'>
              모든 프로젝트는 충분한 사전 이해와 꼼꼼한 검토에서 시작하며, 디자인부터 실행까지의 전 과정을 내부에서 직접 관리합니다.<br/>
              공간의 규모나 용도와 관계없이 항상 같은 기준과 밀도로 작업합니다.
            </p>

            <picture>
              <source
                media="(max-width: 768px)"
                srcSet={imgHowMobile}
              />
              <Image src={imgHow} alt="how" />
            </picture>
          </div>
        </HowContent>
      </AboutSection>

      <AboutSection>
        <OurContent>
          <div>
            <SectionTitle>Our Direction</SectionTitle>
            <p className='korean'>
              노르웨이숲의 비전은 우리가 속한 환경과 자연을 존중하며,<br/>
              한국의 디자인 환경에 실질적으로 기여하는 공간을 통해 함께 성장하는 것입니다.
            </p>

            <Image src={ourDirection1} alt="ourDirection1" />
          </div>

          <OurContentRight>
            <Image src={ourDirection2} alt="ourDirection2" />
          </OurContentRight>
        </OurContent>
      </AboutSection>
    </Wrapper>
  );
};
